/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
import { GetSchedulIntervalInfo, GetDoctorInfo } from "@/api";
import doctor_head from '@/resources/images/doctorDefault.png';
import { mapGetters, mapMutations, mapState } from 'vuex';
import CompDoctor from '@/components/CompDoctor';
import RegTimeChoose from '../apptReg/CompRegTimeChoose';
import moment from 'moment';
import { MUTATION_APPTREG_ADDREGINFO, GETTER_CLINICOBJ } from '@/store/mutation_types';
import '@/store/mutation_types';
export default {
  data: function data() {
    return {
      minDate: '',
      maxDate: '',
      dateWithDot: [],
      doctorId: '',
      doctorInfo: {},
      apptDates: {},
      apptPayFlag: '',
      showChoose: false
    };
  },
  components: {
    CompDoctor: CompDoctor,
    RegTimeChoose: RegTimeChoose
  },
  created: function created() {
    this.doctorId = this.$route.query.id;
    this.getDoctorInfo(this.doctorId);
  },
  mounted: function mounted() {},
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState({
    clinicId: function clinicId(state) {
      return state.clinicId;
    }
  })), mapGetters({
    clinicObj: GETTER_CLINICOBJ
  })), {}, {
    clinicPhotoPath: function clinicPhotoPath() {
      var imgSrc = this.doctorInfo.doctorHeadPicture;
      var clinicPhotoPath = '';

      if (imgSrc && imgSrc != 'null') {
        if (imgSrc.indexOf("http") === -1 && imgSrc.indexOf('data:image') === -1) {
          console.log(imgSrc);
          console.log(Cons.SH_IMGROOT_PATH);
          console.log(Cons.SZ_IMGROOT_PATH);

          if (imgSrc.indexOf('clinic/doctor') > -1) {
            clinicPhotoPath = Cons.SH_IMGROOT_PATH + imgSrc;
          } else {
            clinicPhotoPath = Cons.SZ_IMGROOT_PATH + imgSrc;
          }
        } else {
          clinicPhotoPath = imgSrc;
        }
      } else {
        clinicPhotoPath = doctor_head;
      }

      return clinicPhotoPath;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations({
    setAddRegInfo: MUTATION_APPTREG_ADDREGINFO
  })), {}, {
    getDoctorInfo: function getDoctorInfo(doctorId) {
      var _this = this;

      GetDoctorInfo(doctorId).then(function (data) {
        _this.doctorInfo = data.doctorInfo;
        _this.apptPayFlag = data.apptPayFlag;
        var apptDates = data.apptDates;

        if (data.doctorInfo && data.doctorInfo.apptInWechat === 1) {
          if (apptDates && apptDates.length > 0) {
            _this.minDate = apptDates[0].scheduleDate;
            _this.maxDate = apptDates[apptDates.length - 1].scheduleDate;
            var start = moment(_this.minDate);
            var end = moment(_this.maxDate);
            _this.dateWithDot = apptDates.filter(function (x) {
              return x.surplusQty > 0 && (moment(x.scheduleDate).isBefore(end, 'day') || moment(x.scheduleDate).isSame(end, 'day'));
            }).map(function (x) {
              return x.scheduleDate;
            });
          }
        }

        console.log(data);
      });
    },
    dateSelected: function dateSelected(d) {
      console.log(d);
      var scheduleDate = moment(d).format('YYYY-MM-DD');
      console.log(scheduleDate);
      var addRegInfo = {};
      var doctorInfo = this.doctorInfo;
      addRegInfo.clinicId = this.clinicId;
      addRegInfo.clinicName = this.clinicObj.scrmClinic.clinicName;
      addRegInfo.schedulDoctorModel = 2; //医生排班

      addRegInfo.doctorDeptId = doctorInfo.employeeId;
      addRegInfo.doctorId = doctorInfo.employeeId;
      addRegInfo.doctorName = doctorInfo.doctorName;
      addRegInfo.schduleDate = scheduleDate;
      addRegInfo.apptPayFlag = this.apptPayFlag;
      this.setAddRegInfo(addRegInfo);
      this.showChoose = true;
    },
    nextWeek: function nextWeek(startDate, endDate) {},
    lastWeek: function lastWeek(startDate, endDate) {}
  })
};